import { func_validation } from "functions";
import { useEffect, useState } from "react";

export function useResetModal(props) {
    const {
        isModalVisible_generateInvoice,
        setGenerateInvoice_endDate,
        generateInvoice_endDate,

        isAccountRecordUpdatedSuccessfully
    } = props;

    const [isModalResetRequired, setIsModalResetRequired] = useState(false);
    
    function updateResetModalState() {
        if (func_validation.isStringTrimEmpty(generateInvoice_endDate))
            setIsModalResetRequired(false);
    }
    function resetModalState() {
        if ((!isModalVisible_generateInvoice)) {
            setIsModalResetRequired(true);
            
            if (func_validation.isFunction(setGenerateInvoice_endDate))
                setGenerateInvoice_endDate("");
        }
    }
    useEffect(() => {
        updateResetModalState();
    }, [isModalResetRequired]);

    return {
        isModalResetRequired,
        resetModalState
    };
}